module.exports = __webpack_public_path__ + "img/NIS_Technical.13c97410.svg";